/* global axios */
import ApiClient from './ApiClient';

class EmailMarketingTemplatesAPI extends ApiClient {
  constructor() {
    super('email_marketing_templates', { accountScoped: true });
  }

  list({ context, category } = {}) {
    return axios.get(this.url, { params: { context, category } });
  }

  create(data) {
    return axios.post(this.url, { email_marketing_template: data });
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, { email_marketing_template: data });
  }

  destroy(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  previewDraft({ subject, body_html: bodyHtml, contactId }) {
    return axios.post(`${this.url}/preview_draft`, {
      subject,
      body_html: bodyHtml,
      contact_id: contactId || undefined,
    });
  }

  testSend({ subject, body_html: bodyHtml, email }) {
    return axios.post(`${this.url}/test_send`, {
      subject,
      body_html: bodyHtml,
      email: email || undefined,
    });
  }

  preview(id, { contactId } = {}) {
    return axios.get(`${this.url}/${id}/preview`, {
      params: contactId ? { contact_id: contactId } : {},
    });
  }
}

export default new EmailMarketingTemplatesAPI();
